import * as React from 'react'
import { useState } from 'react'
import { bundleIcon, MailAlertColor, MailAlertRegular, MailSettingsFilled, MailSettingsRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { Button, Tooltip } from '@fluentui/react-components'
import useAxios from '../../../../hooks/useAxios'
import useUser from '../../../../hooks/useUser'
import { AxiosResponse } from 'axios'
import LinkUserFolderDialogBody, {
    getLinkUserFolderDialogBodySchema,
    LinkUserFolderDialogBodyProps,
    LinkUserFolderDialogBodyValues,
} from '../../../components/Dialog/Message/LinkUserFolderDialogBody'
import HammockFormDialog from '../../../components/Dialog/HammockFormDialog'
import { EmailOverviewProps } from './FileEmailOverview'

const SynchronizeMailIcon = bundleIcon(MailSettingsFilled, MailSettingsRegular)

export type EmailHeaderActionsOverviewProps = {
    emailUserFolderId: string
    setEmailUserFolderId: (folderId: string) => void
    reload: () => void
}

export default function FileEmailHeaderActionsButtons(props: EmailOverviewProps & EmailHeaderActionsOverviewProps) {
    const axios = useAxios()
    const { t: translate } = useTranslation()
    const { currentMailbox } = useUser()

    const [openSynchronizeUserFolder, setOpenSynchronizeUserFolder] = useState<boolean>()

    return (
        <>
            <Tooltip
                withArrow
                relationship={'label'}
                content={translate(props.emailUserFolderId ? 'email.filing.unsubscribe' : 'email.filing.subscribe')}
            >
                <Button
                    icon={props.emailUserFolderId ? <MailAlertColor /> : <MailAlertRegular />}
                    appearance={'secondary'}
                    onClick={() => {
                        axios.post(`/email/${currentMailbox}/folder/${props.file.reference}/toggle`).then((response: AxiosResponse<string>) => {
                            props.setEmailUserFolderId(response.data)
                        })
                    }}
                />
            </Tooltip>
            <Tooltip withArrow relationship={'label'} content={translate('email.filing.synchronize.tooltip')}>
                <Button icon={<SynchronizeMailIcon />} appearance={'secondary'} onClick={() => setOpenSynchronizeUserFolder(true)} />
            </Tooltip>
            <HammockFormDialog<LinkUserFolderDialogBodyValues, LinkUserFolderDialogBodyProps>
                open={openSynchronizeUserFolder}
                setOpen={setOpenSynchronizeUserFolder}
                dialogFormProps={() => ({
                    initialValues: {
                        create: false,
                        id: props.emailUserFolderId,
                        parentFolderId: undefined,
                        name: undefined,
                    },
                    onSubmit: () => {},
                    validationSchema: getLinkUserFolderDialogBodySchema(axios, translate),
                })}
                dialogFormBody={LinkUserFolderDialogBody}
                dialogFormBodyProps={() => ({
                    file: props.file,
                    userEmail: currentMailbox,
                    callback: () => props.reload(),
                })}
            />
        </>
    )
}
